@for (item of options; track item) {
  <div class="form-check" [ngClass]="{'inline-block': hasSeveralColumns()}">
    <input
            class="form-check-input"
            id="{{ item.value }}"
            type="checkbox"
            [(ngModel)]="item.checked"
            (change)="onInnerToggle()"> {{ item.label }}
    <label class="form-check-label" for="{{ item.value }}"></label>
  </div>
}
